import React, { useContext } from 'react';
import { StyledWrapper } from 'modules/assignment-cards/styled';
import { Loading } from 'components/Loading';
import DriverPoolContext from '../context';
import DriverPoolCard from '../driver-card';
import { Flexer } from '@ontruck/orc';

const t = {
  no_drivers: 'Driver pool is empty.',
};

const DriverPoolSection = ({ vertical, assignActionComponent }) => {
  const { availableDrivers, isLoading } = useContext(DriverPoolContext);

  const hasElements = availableDrivers?.length > 0;

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Loading />
      </div>
    );
  }

  return (
    <>
      {hasElements && (
        <StyledWrapper data-testid="driver_pool_container" vertical={vertical}>
          {availableDrivers?.map(({ id }) => (
            <DriverPoolCard
              key={id}
              id={id}
              vertical={vertical}
              assignActionComponent={assignActionComponent}
            />
          ))}
        </StyledWrapper>
      )}
      {!hasElements && (
        <Flexer.Parent flexDirection="column" alignItems="center">
          <Flexer.Child mBottom="S" data-testid="driver_pool_empty">
            {t.no_drivers}
          </Flexer.Child>
        </Flexer.Parent>
      )}
    </>
  );
};

export default DriverPoolSection;
